import { Router } from '@vaadin/router';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import '@vaadin/vaadin-icons/vaadin-icons.js';

class KbFolderitem extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state[this.state.langCode];
        if(this.node){
            this.myRender()
        }
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }


    stateChange(state){
        this.state = state;
        this.string = this.state[this.state.langCode];
        if(this.node){
            this.myRender()
        }
    }
    
    myRender(){
        render(this.tocItemTemplate(), this.shadowRoot);
        }
       
    tocItemTemplate(){
       return html`
            <style> 
                #iconspan{
                    display:inline-block;
                    width:1.5rem;
                }
                .selected{
                    background-color: var(--kb-base-highlight);
                }
                .subitems{
                    margin-left:1rem;
                    padding:.1rem;
                }
                .tocicon{
                    width:1rem;
                    cursor: pointer;
                }
                .tocitemtitle{
                    cursor: pointer;
                    padding:.1rem;
                }
            </style>
            <div>
                <span id='iconspan'>${this._icon()}</span><span class="tocitemtitle ${this.node.selected ? 'selected':''}" @click="${this._itemClicked.bind(this)}">${this.node.name}</span>
                <div class='subitems'>
                    ${this.node.children && this.node.open ? this.node.children.map((node)=> html`<kb-folderitem .node="${node}"></kb-folderitem>`) : html``}
                <div>
            </div>
       `;
    }
    
    _icon(){

        if(this.node.nodes || this.node.children){
            if(this.node.open){
                    return html`<iron-icon class='tocicon' icon="vaadin:angle-down" @click="${this.toggleNode.bind(this)}"></iron-icon>`;
                } else {
                    return html`<iron-icon class='tocicon' icon="vaadin:angle-right"  @click="${this.toggleNode.bind(this)}"></iron-icon>`;
                }
        } else {
            return html`&nbsp;`
           }
    }

    toggleNode(){
        this.node.open = !this.node.open;
        this.myRender();
    }
    _itemClicked(e){
        if(this.node.id){
            this.dispatchEvent(new CustomEvent('folderItemClicked', {
                bubbles: true,
                composed: true,
                detail: this.node
                }));
        }
    }
}

customElements.define('kb-folderitem', KbFolderitem)
